(() => {
  if (window.cuppyLiftBundleReady) return;
  window.cuppyLiftBundleReady = true;
  const positions = root => {
    const options = JSON.parse(root.dataset.optionNames || '["מידה","צבע"]');
    return {
      color: options.findIndex(name => /^(צבע|colou?r)$/i.test(name)),
      size: options.findIndex(name => /^(מידה|size)$/i.test(name))
    };
  };
  function replaceOptions(select, values, fallback, label = value => value) {
    if (!select) return;
    const previous = select.value;
    const selected = values.includes(previous) ? previous : fallback ? values[0] || '' : '';
    const entries = values.map(value => [value, label(value)]);
    if (!selected) entries.unshift(['', 'בחרי אפשרות']);
    const existing = [...select.options];
    if (existing.length !== entries.length || entries.some(([value, text], i) => existing[i].value !== value || existing[i].textContent !== text || existing[i].disabled !== (value === '') || existing[i].hidden)) {
      select.replaceChildren(...entries.map(([value, text]) => {
        const option = new Option(text, value);
        option.disabled = value === '';
        return option;
      }));
    }
    select.value = selected;
    select.disabled = values.length === 0;
  }
  function syncOptions(root, selects, variants, fallback = true, sizeLabel) {
    const {color, size} = positions(root);
    if (color < 0 || size < 0 || !selects[color] || !selects[size]) return;
    const available = variants.filter(variant => variant.available === true);
    const values = (index, list) => [...new Set(list.map(variant => variant.options[index]))];
    const colors = new Set(values(color, available));
    replaceOptions(selects[color], values(color, variants).filter(value => colors.has(value)), fallback);
    const matching = available.filter(variant => variant.options[color] === selects[color].value);
    const sizes = new Set(values(size, matching));
    replaceOptions(selects[size], values(size, variants).filter(value => sizes.has(value)), fallback, sizeLabel);
    return available.find(variant => variant.options.every((value, index) => value === selects[index]?.value));
  }
  window.cuppyLiftAvailability = {positions, sync: syncOptions};
  const names = {'שמנת':'לבן','ניוד':'בז׳','מנומר חום':'מנומר קפה'};
  const keys = {'שחור':'black','שמנת':'white','לבן':'white','ניוד':'beige','בז׳':'beige','בז':'beige','מוקה':'mocha','מנומר חום':'coffee','מנומר קפה':'coffee','מנומר ורוד':'pink'};
  const shapeKeys = {'שוקולד':'chocolate','לאטה':'latte','ניוד':'nude','חול':'sand','שחור':'black'};
  let configured = {};
  const initialized = new WeakSet();
  const photo = variant => variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
  const currency = new Intl.NumberFormat('he-IL', {style:'currency',currency:'ILS'});
  function imageFor(variants, variant, color, handle = 'lift') {
    const mapping = handle === 'high-panty' ? configured.__shape || {} : configured;
    const key = handle === 'high-panty' ? shapeKeys[color] : keys[color];
    return mapping[key] || photo(variant) || photo(variants.find(v => v.option2 === color && photo(v)));
  }
  function applyImage(image, src, label) {
    if (!image) return;
    if (!image.dataset.cuppyOriginal) {image.dataset.cuppyOriginal = image.getAttribute('src');image.dataset.cuppyOriginalAlt = image.alt;}
    const next = src || image.dataset.cuppyOriginal;
    if (image.getAttribute('src') !== next) { image.removeAttribute('srcset'); image.src = next; }
    image.alt = src ? label : image.dataset.cuppyOriginalAlt;
  }
  const lowSizes = new Set(['M', 'L', 'XL']);
  function updateSize(select, variants, color, root) {
    if (!select) return;
    const indexes = positions(root);
    const wrapper = select.closest('.select');
    if (!wrapper) return;
    wrapper.classList.add('cuppy-lift-size-select');
    let display = wrapper.querySelector('.cuppy-size-display');
    if (!display) {
      display = document.createElement('span');
      display.className = 'cuppy-size-display';
      display.setAttribute('aria-hidden', 'true');
      const size = document.createElement('bdi');
      size.className = 'cuppy-size-value';
      const badge = document.createElement('span');
      badge.className = 'cuppy-low-stock-badge';
      badge.textContent = 'כמעט אזל';
      display.append(size, badge);
      wrapper.append(display);
    }
    for (const option of select.options) {
      const available = variants.some(v => v.available === true && v.options[indexes.size] === option.value && v.options[indexes.color] === color);
      const low = available && lowSizes.has(option.value);
      option.textContent = `${option.value}${low ? ' — כמעט אזל' : ''}`;
    }
    display.querySelector('.cuppy-size-value').textContent = select.value;
    const available = variants.some(v => v.available === true && v.options[indexes.size] === select.value && v.options[indexes.color] === color);
    display.querySelector('.cuppy-low-stock-badge').hidden = !available || !lowSizes.has(select.value);
  }
  function updateBundle(root) {
    const variants = JSON.parse(root.querySelector('[data-has-variants]').textContent);
    const {color: colorIndex, size: sizeIndex} = positions(root);
    root.querySelectorAll('.quantity-break__selector-item').forEach(row => {
      const selects = [...row.querySelectorAll('.quantity-break__variant-select')];
      const variant = syncOptions(root, selects, variants, true, value => `${value}${lowSizes.has(value) ? ' — כמעט אזל' : ''}`);
      const color = selects[colorIndex]?.value;
      updateSize(selects[sizeIndex], variants, color, root);
      row.dataset.selectedId = variant?.id || '';
      const offer = row.closest('.quantity-break')?.dataset.input;
      if (offer && root.selectedVariants) root.selectedVariants[offer][Number(row.dataset.selectIndex)] = variant?.id || '';
      applyImage(row.querySelector('.cuppy-bundle-photo img'),imageFor(variants,variant,color),`${names[color] || color} — ${selects[0]?.value || ''}`);
    });
    const selectedOffer = root.querySelector('input[name="quantity"]:checked')?.dataset.input;
    if (selectedOffer && root.selectedVariants) root.formVariants = root.selectedVariants[selectedOffer];
    const form = document.getElementById(`product-form-${root.dataset.section}`);
    const input = form?.querySelector('[name="id"]');
    const selected = variants.find(variant => variant.available === true && String(variant.id) === String(root.formVariants?.[0]));
    if (input && selected) {
      const previousUnavailable = !variants.some(variant => variant.available === true && String(variant.id) === input.value);
      input.value = selected.id;
      input.disabled = false;
      if (previousUnavailable) {
        const button = form.querySelector('[name="add"]');
        if (button && Number(button.dataset.validFields || 0) >= Number(button.dataset.requiredFields || 0)) {
          button.disabled = false;
          button.dataset.unavailable = 'false';
          const label = button.querySelector('.main-atc__label__text');
          if (label) label.textContent = button.dataset.customLabel || window.variantStrings?.addToCart || label.textContent;
        }
      }
    } else if (form && !variants.some(variant => variant.available === true)) {
      if (input) input.disabled = true;
      const button = form.querySelector('[name="add"]');
      if (button) button.disabled = true;
    }
  }
  function updateUpsell(root) {
    const source = root.querySelector('[data-upsell-variants]');
    if (!source) return;
    const variants = JSON.parse(source.textContent);
    const selects = [...root.querySelectorAll('.upsell__variant-picker select')];
    const lift = root.dataset.handle === 'lift';
    const shape = root.dataset.handle === 'high-panty';
    if (lift) {
      syncOptions(root, selects, variants, true, value => `${value}${lowSizes.has(value) ? ' — כמעט אזל' : ''}`);
      updateSize(selects[0], variants, selects[1]?.value, root);
    }
    const variant = variants.find(v => v.options.every((value,i) => value === selects[i]?.value));
    if (!variant) return;
    const color = selects[1]?.value;
    applyImage(root.querySelector('.upsell__image img'),lift || shape ? imageFor(variants,variant,color,root.dataset.handle) : photo(variant) || photo(variants.find(v => v.option2 === color && photo(v))),`${lift ? names[color] || color : color || ''} — ${selects[0]?.value || ''}`);
    const regular = root.querySelector('.upsell__price .regular-price'), compare = root.querySelector('.upsell__price .compare-price');
    const price = Math.round(variant.price * Number(root.dataset.percentageLeft || 1) - Number(root.dataset.fixedDiscount || 0));
    const baseline = Math.max(variant.price,variant.compare_at_price || 0);
    if (regular) regular.textContent = currency.format(price / 100);
    if (compare) {compare.textContent = currency.format(baseline / 100);compare.classList.toggle('hidden',baseline <= price);}
  }
  function initialize(root, update) {
    if (initialized.has(root)) return;
    initialized.add(root);
    if (root.hasAttribute('data-cuppy-lift-bundle')) {
      root.updateUnavailable = false;
      root.addEventListener('change', () => update(root), true);
      const form = document.getElementById(`product-form-${root.dataset.section}`);
      form?.addEventListener('submit', event => {
        update(root);
        const ids = root.formVariants || [];
        const variants = JSON.parse(root.querySelector('[data-has-variants]').textContent);
        if (!ids.length || ids.some(id => !variants.some(variant => variant.available === true && String(variant.id) === String(id)))) {
          event.preventDefault();
          event.stopImmediatePropagation();
          form.closest('product-form')?.handleErrorMessage?.('בחרי מידה וצבע זמינים לכל פריט.');
        }
      }, true);
    } else if (root.dataset.handle === 'lift') {
      root.addEventListener('change', () => update(root), true);
    }
    root.addEventListener('change', () => requestAnimationFrame(() => update(root)));
    requestAnimationFrame(() => {
      const selects = [...root.querySelectorAll('.upsell__variant-picker select')];
      const previous = selects[1]?.value;
      update(root);
      if (previous && previous !== selects[1]?.value) selects[1].dispatchEvent(new Event('change',{bubbles:true}));
    });
  }
  function initializePicker(root) {
    if (initialized.has(root)) return;
    const selects = [...root.querySelectorAll('.product-form__input select')];
    if (selects.length !== 2) return;
    initialized.add(root);
    const variants = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
    const update = () => syncOptions(root, selects, variants);
    root.updateVariantStatuses = update;
    root.addEventListener('change', event => {
      if (!update()) {
        event.stopImmediatePropagation();
        root.toggleAddButton?.(true, window.variantStrings?.soldOut);
      }
    }, true);
    const variant = update();
    if (variant) selects[0].dispatchEvent(new Event('change', {bubbles:true}));
    else root.toggleAddButton?.(true, window.variantStrings?.soldOut);
  }
  function scan() {
    document.querySelectorAll('[data-cuppy-lift-bundle]').forEach(root => initialize(root,updateBundle));
    document.querySelectorAll('[data-cuppy-lift-picker]').forEach(initializePicker);
    document.querySelectorAll('cart-drawer-upsell, product-info-upsell').forEach(root => initialize(root,updateUpsell));
    document.querySelectorAll('img[data-cuppy-product="lift"], img[data-cuppy-product="high-panty"]').forEach(image => {
      const shape = image.dataset.cuppyProduct === 'high-panty';
      const src = shape ? configured.__shape?.[shapeKeys[image.dataset.cuppyColor]] : configured[keys[image.dataset.cuppyColor]];
      if(src) applyImage(image,src,shape ? image.dataset.cuppyColor : names[image.dataset.cuppyColor] || image.dataset.cuppyColor);
    });
  }
  function start() {
    const config = document.getElementById('cuppy-lift-media-config');
    if (config) configured = JSON.parse(config.textContent);
    scan();
    let scheduled = false;
    new MutationObserver(records => {
      if (scheduled || !records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('cart-drawer-upsell, product-info-upsell, [data-cuppy-lift-bundle], [data-cuppy-lift-picker], img[data-cuppy-product], #CartDrawer') || n.querySelector?.('cart-drawer-upsell, product-info-upsell, [data-cuppy-lift-bundle], [data-cuppy-lift-picker], img[data-cuppy-product]'))))) return;
      scheduled = true;
      requestAnimationFrame(() => {scheduled = false;scan();});
    }).observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',scan);
})();
